import { faCircleNotch } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { COMMON_NAMESPACE } from "constants/i18n-namespaces";
import { LoadingButton } from "kubra-ux-forge";
import React from "react";
import { useTranslation } from "react-i18next";

interface ContinueButtonProps {
  loading: boolean;
  onClick: () => void;
}

const ContinueButton: React.FC<ContinueButtonProps> = ({
  loading,
  onClick,
}) => {
  const { t } = useTranslation();

  return (
    <div className="ez-pay-payable-continue-button">
      <LoadingButton
        loadingState="text"
        onClick={onClick}
        className="validate-button"
        type="submit"
        disabled={loading}
        data-cy="button-loading"
      >
        {loading && (
          <div className="button-icon">
            <FontAwesomeIcon icon={faCircleNotch} className="fa-spin" />
          </div>
        )}
        {!loading && <div>{t("continue", { ns: COMMON_NAMESPACE })} </div>}
      </LoadingButton>
    </div>
  );
};

export default ContinueButton;
